import { Box } from '@mui/material';
import { format } from 'date-fns';
import { FC, useCallback } from 'react';
import theme from 'App.theme';
import DatePicker from 'components/DatePicker';
import { MaybeDate } from 'components/DatePicker/DateInput';

type TDateFilter = FC<{
  activeValue?: string;
  onChange: (val: string) => void;
}>;

const DateFilter: TDateFilter = ({ activeValue, onChange }) => {
  const setDateFilter = useCallback(
    (date: MaybeDate) => {
      let value = '';

      if (date) {
        //value = endOfDay(new Date(date)).toISOString();
        value = format(new Date(date), 'yyyy-MM-dd');
        if (value == activeValue) return;
      }

      onChange(value);
    },
    [activeValue, onChange],
  );

  return (
    <Box sx={{ p: theme.layout.spacing.small }}>
      <DatePicker selected={activeValue} size="small" onSelect={setDateFilter} />
    </Box>
  );
};

export default DateFilter;
